import { render, staticRenderFns } from "./serviceOrderDetail.vue?vue&type=template&id=e85a17e4&"
import script from "./serviceOrderDetail.vue?vue&type=script&lang=js&"
export * from "./serviceOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports